import { __require as n } from "./for_each_object.js";
var r, a;
function f() {
  if (a) return r;
  a = 1;
  var t = n();
  return r = function(o, u) {
    var e = [];
    return t(o, function(c, i) {
      e.push(u(c, i));
    }), e;
  }, r;
}
export {
  f as __require
};
